import {
  TableCellAttribute,
  TableCellStyles,
  TableDataAdaptee,
  TableHeadData,
  TableRowData,
  UsersXForYData,
} from 'src/app/interfaces/tables.interfaces';
import { PendingUserInvolvement } from 'src/app/swagger-api';
import {
  defaultTableHead,
  manageRequestsVsInvitesTableCellAttributes,
  manageTableHead,
  noManageRequestsVsInvitesTableCellAttributes,
  sharedEntityTableRowData,
} from '../table-users-list.data';
import { tableComponentStyles } from './table.styles';

export class UsersRequestsTableDataAdaptee implements TableDataAdaptee {
  public constructor(private dictionary: UsersXForYData) {}

  public getTableHeadData(): TableHeadData[] {
    return this.isManagingAllowed() ? manageTableHead : defaultTableHead;
  }

  public getCellAttributes(): TableCellAttribute[] {
    return this.isManagingAllowed()
      ? manageRequestsVsInvitesTableCellAttributes
      : noManageRequestsVsInvitesTableCellAttributes;
  }

  public getCellStyles(): TableCellStyles {
    return this.isManagingAllowed()
      ? tableComponentStyles.tableWithDateAndManage
      : tableComponentStyles.tableWithoutManageAction;
  }

  public createTableBody(): TableRowData[] {
    return this.dictionary.usersRequests.map((request: PendingUserInvolvement, id: number) =>
      sharedEntityTableRowData(request, id, this.dictionary.entityId, false),
    );
  }

  private isManagingAllowed(): boolean {
    return this.dictionary.allowManaging;
  }
}
